import { Image, ScrollView, StyleSheet, TouchableOpacity, View } from "react-native";
import { fp, hp, spH, spV, wp } from "utils/normalizeV2";
import { getAIChatHistory, postAiChat } from "appRedux/reducers/chatSlice";
import { useRef, useState } from "react";

import { ActivityIndicator } from "react-native";
import Buttons from "components/Buttons";
import ChatCarouselCop from "./chatCarouselCop";
import { Colors } from "colors";
import DownloadAppModal from "./downloadAppModal";
import GuestDownloadModal from "./guestDownloadModal";
import { Images } from "assets";
import Input from "components/Input";
import JumpingDots from "./typingDots";
import OutfitProductsModal from "./outfitProductsModal";
import { Svg } from "assets/svg";
import VText from "components/VText";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useRouter } from "expo-router";
import { useSelector } from "react-redux";

const PdpStylistView = ({ productData, isOpenAskAI, setIsOpenAskAI }) => {
    const scrollViewRef = useRef();
    const dispatch = useDispatch();
    const _downloadAppRef = useRef();
    const _guestDownloadModalRef = useRef();
    const _uploadImageModalRef = useRef();
    const _outfitProductsModalRef = useRef();
    const [chatHistory, setChatHistory] = useState([]);
    const [inputValue, setInputValue] = useState("");
    const [isTyping, setIsTyping] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [handleCarouselIndex, setHandleCarouselIndex] = useState([]);
    const [promentCount, setPromentCount] = useState(0);
    const carouselRefs = useRef([]);
    const [imageUrl, setImageUrl] = useState("");
    const userProfile = useSelector((state) => state.ProfileReducer.profileData);
    const [isMicRecording, setIsMicRecording] = useState(false);
    const [isTranscript, setIsTranscript] = useState(false);

    useEffect(() => {
        setImageUrl(productData?.imageUrls[0]);
        dispatch(getAIChatHistory({ pageNo: 1 }))
            .then((res) => {
                setIsLoading(false);
                let reverseData = [...res?.payload?.data];
                reverseData.reverse();
                setChatHistory(reverseData);
                scrollViewRef?.current?.scrollToEnd();
                const count = reverseData.filter((item) => item?.by === "user" && item?.platform === "web").length;
                setPromentCount(count);
                if (count >= 3) {
                    _downloadAppRef?.current?.show();
                }
            })
            .catch((err) => {
                console.log("err--", err);
            });
    }, []);

    useEffect(() => {
        scrollViewRef?.current?.scrollToEnd();
    }, [chatHistory]);

    const handleSendMessage = () => {
        if (promentCount >= 3) {
            _downloadAppRef?.current?.show();
            return;
        }
        scrollViewRef?.current?.scrollToEnd();
        setIsTyping(true);
        setChatHistory([
            ...chatHistory,
            { message: inputValue, by: "user", createdDate: new Date(), imageUrl: imageUrl },
        ]);
        let data = [
            {
                message: inputValue,
                by: "user",
                createdDate: new Date(),
                productId: productData?.productId,
                imageUrl: imageUrl,
            },
        ];
        setInputValue("");
        setImageUrl("");
        dispatch(postAiChat(data))
            .then((res) => {
                setChatHistory([
                    ...chatHistory,
                    { message: inputValue, by: "user", createdDate: new Date(), imageUrl: imageUrl },
                    { ...res?.payload?.data, by: "assistant", createdDate: new Date() },
                ]);
                setIsTyping(false);
                if (promentCount == 2) {
                    _downloadAppRef?.current?.show();
                }
                setPromentCount(promentCount + 1);
                scrollViewRef?.current?.scrollToEnd({ xoffset: 8000 });
            })
            .catch((err) => {
                // console.log("err", err);
            })
            .finally(() => {
                setInputValue("");
            });
    };

    const handleViewProduct = (data) => {
        setChatHistory([...chatHistory, { message: "View Products", by: "user", createdDate: new Date() }]);
        setIsTyping(true);
        scrollViewRef?.current?.scrollToEnd();
        setTimeout(() => {
            setChatHistory([
                ...chatHistory,
                { message: "View Products", by: "user", createdDate: new Date() },
                {
                    message: "View Products",
                    by: "assistant",
                    createdDate: new Date(),
                    showProductsSlider: true,
                    productsData: data,
                },
            ]);
            setIsTyping(false);
            scrollViewRef?.current?.scrollToEnd();
        }, 2000);
    };

    const redirectToProduct = (product) => {
        window.open(
            `/product?id=${product?.id}&brand=${product?.brandName}&product=${product?.productName}&gender=${product?.gender}`,
            "_blank"
        );
    };

    const handleViewOutfit = (data) => {
        setChatHistory([...chatHistory, { message: "View Outfits", by: "user", createdDate: new Date() }]);
        setIsTyping(true);
        scrollViewRef?.current?.scrollToEnd();
        setTimeout(() => {
            setChatHistory([
                ...chatHistory,
                { message: "View Outfits", by: "user", createdDate: new Date() },
                {
                    message: "View Outfits",
                    by: "assistant",
                    createdDate: new Date(),
                    showOutfitSlider: true,
                    outfitData: data,
                },
            ]);
            setIsTyping(false);
            scrollViewRef?.current?.scrollToEnd();
        }, 2000);
    };

    const showOutfitModal = (data) => {
        setSelectedProducts(data);
        _outfitProductsModalRef?.current?.show();
    };
    const handleDownloadApp = () => {
        _downloadAppRef?.current?.show();
    };

    const handleMicPress = () => {
        setIsMicRecording(true);

        if (navigator?.mediaDevices && navigator?.mediaDevices?.getUserMedia) {
            navigator?.mediaDevices
                ?.getUserMedia({ audio: true })
                .then((stream) => {
                    const mediaRecorder = new MediaRecorder(stream);
                    mediaRecorder.start();
                    const speechRecognition = new (window.SpeechRecognition || window.webkitSpeechRecognition)();
                    speechRecognition.start();
                    speechRecognition.onresult = (event) => {
                        mediaRecorder.stop();
                        setIsMicRecording(false);
                        const transcript = event.results[0][0].transcript;
                        setInputValue(transcript);
                        setIsTranscript(true);
                    };
                    speechRecognition.onerror = (event) => {
                        console.error("Speech recognition error:", event.error);
                    };
                    const audioChunks = [];
                    mediaRecorder.addEventListener("dataavailable", (event) => {
                        audioChunks.push(event.data);
                    });

                    mediaRecorder.addEventListener("stop", () => {
                        setIsMicRecording(false);
                    });

                    setTimeout(() => {
                        mediaRecorder.stop();
                        setIsMicRecording(false);
                    }, 6000); // Stop recording after 5 seconds
                })
                .catch((error) => {
                    setIsMicRecording(false);
                    console.error("Error accessing the microphone", error);
                });
        } else {
            setIsMicRecording(false);
            console.error("getUserMedia not supported on this browser!");
        }
    };

    const handleCameraPress = () => {
        _uploadImageModalRef?.current?.show();
    };

    const handleAskAI = () => {
        if (!userProfile?.userId) {
            _guestDownloadModalRef?.current?.show();
            return;
        }
    };

    return (
        <View style={{ alignItems: "center", width: wp(443) }}>
            <TouchableOpacity onPress={() => setIsOpenAskAI(false)} style={styles.closeButton}>
                <Image
                    accessibilityLabel="Close Icon"
                    source={Svg.closeIcon}
                    style={{ width: wp(30), height: hp(30) }}
                />
            </TouchableOpacity>
            <VText style={styles.title}>Ask AI Stylist</VText>
            {isLoading && <ActivityIndicator size="large" color={Colors.primary} style={{ marginTop: spV(30) }} />}
            {!isLoading && (
                <View style={{ justifyContent: "center", alignItems: "center", width: wp(430), marginTop: spV(30) }}>
                    <ScrollView
                        contentOffset={{ x: 8000 }}
                        onLayout={() => scrollViewRef.current.scrollToEnd()}
                        ref={scrollViewRef}
                        style={{ maxHeight: hp(500), minHeight: hp(300), width: wp(430), overflow: "scroll" }}
                    >
                        {chatHistory.length === 0 && (
                            <View style={{ marginVertical: spV(30), alignItems: "center" }}>
                                <Image
                                    source={Images.aiStylistImage}
                                    resizeMode="contain"
                                    accessibilityLabel="AI Stylist Image"
                                    style={{ width: wp(350), height: hp(240), marginTop: spV(20) }}
                                />
                                <VText style={styles.description}>
                                    From personalized product recommendations to personalized outfit styling, the Vêtir
                                    AI Stylist is here to answer all your fashion questions.
                                </VText>
                            </View>
                        )}
                        {chatHistory.length > 0 &&
                            chatHistory.map((item, index) => {
                                switch (item?.by) {
                                    case "user":
                                        return (
                                            <View style={{ alignItems: "flex-end", width: "100%" }}>
                                                {item?.imageUrl && (
                                                    <View
                                                        style={{
                                                            padding: spH(10),
                                                            borderRadius: fp(10),
                                                        }}
                                                    >
                                                        <Image
                                                            source={{ uri: item?.imageUrl }}
                                                            accessibilityLabel="User Message Image"
                                                            style={{ width: wp(70), height: hp(100) }}
                                                        />
                                                    </View>
                                                )}
                                                {item?.message && (
                                                    <VText style={styles.userMessage}>{item?.message}</VText>
                                                )}
                                                <VText
                                                    style={{ fontSize: fp(10), fontWeight: "300", color: "#888888" }}
                                                >
                                                    {new Date(item?.createdDate).toLocaleTimeString("en-US", {
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                    }) +
                                                        ", " +
                                                        new Date(item?.createdDate).toLocaleDateString("en-US", {
                                                            day: "2-digit",
                                                            month: "short",
                                                        })}
                                                </VText>
                                            </View>
                                        );

                                    case "assistant":
                                        if (item?.showProductsSlider && item?.productsData) {
                                            return (
                                                <View style={{ alignItems: "flex-start", width: "100%" }}>
                                                    <View style={{ flexDirection: "row", alignItems: "center" }}>
                                                        <View style={styles.carouselContainer}>
                                                            <ChatCarouselCop
                                                                data={item?.productsData}
                                                                buttonText="Shop Product"
                                                                handleRedirect={redirectToProduct}
                                                            />
                                                        </View>
                                                    </View>
                                                    <VText
                                                        style={{
                                                            fontSize: fp(10),
                                                            fontWeight: "300",
                                                            color: "#888888",
                                                            marginLeft: spH(40),
                                                        }}
                                                    >
                                                        {new Date(item?.createdDate).toLocaleTimeString("en-US", {
                                                            hour: "2-digit",
                                                            minute: "2-digit",
                                                        }) +
                                                            ", " +
                                                            new Date(item?.createdDate).toLocaleDateString("en-US", {
                                                                day: "2-digit",
                                                                month: "short",
                                                            })}
                                                    </VText>
                                                </View>
                                            );
                                        }

                                        if (item?.showOutfitSlider && item?.outfitData) {
                                            return (
                                                <View style={{ alignItems: "flex-start", width: "100%" }}>
                                                    <View
                                                        style={{
                                                            flexDirection: "row",
                                                            alignItems: "center",
                                                            gap: spH(10),
                                                        }}
                                                    >
                                                        {/* <Image accessibilityLabel="AI Logo" source={Svg.aiLogo} style={{ width: wp(20), height: hp(20), alignSelf: "flex-start", marginTop: spV(15) }} /> */}
                                                        {/* <View style={styles.AIMessage}> */}
                                                        <ChatCarouselCop
                                                            data={item?.outfitData}
                                                            buttonText="Shop Outfit"
                                                            handleRedirect={showOutfitModal}
                                                        />

                                                        {/* </View> */}
                                                    </View>
                                                    <VText
                                                        style={{
                                                            fontSize: fp(10),
                                                            fontWeight: "300",
                                                            color: "#888888",
                                                            marginLeft: spH(40),
                                                        }}
                                                    >
                                                        {new Date(item?.createdDate).toLocaleTimeString("en-US", {
                                                            hour: "2-digit",
                                                            minute: "2-digit",
                                                        }) +
                                                            ", " +
                                                            new Date(item?.createdDate).toLocaleDateString("en-US", {
                                                                day: "2-digit",
                                                                month: "short",
                                                            })}
                                                    </VText>
                                                </View>
                                            );
                                        } else {
                                            return (
                                                <View style={{ alignItems: "flex-start", width: "100%" }}>
                                                    <View
                                                        style={{
                                                            flexDirection: "row",
                                                            alignItems: "center",
                                                            gap: spH(10),
                                                        }}
                                                    >
                                                        {/* <Image accessibilityLabel="AI Logo" source={Svg.aiLogo} style={{ width: wp(20), height: hp(20), alignSelf: "flex-start", marginTop: spV(15) }} /> */}
                                                        <View style={styles.AIMessage}>
                                                            <VText
                                                                style={{
                                                                    fontSize: fp(16),
                                                                    fontWeight: "300",
                                                                    lineHeight: fp(20),
                                                                }}
                                                            >
                                                                {item?.message}
                                                            </VText>
                                                            {item.showProductsModal && (
                                                                <View
                                                                    style={{
                                                                        alignItems: "center",
                                                                        gap: spH(10),
                                                                        marginTop: spV(10),
                                                                    }}
                                                                >
                                                                    {item?.products?.length > 0 && (
                                                                        <Buttons
                                                                            textStyle={styles.buttonText}
                                                                            containerStyle={styles.button}
                                                                            text="View Products"
                                                                            onPress={() =>
                                                                                handleViewProduct(item?.products)
                                                                            }
                                                                        />
                                                                    )}
                                                                    {item?.outfits?.length > 0 && (
                                                                        <Buttons
                                                                            textStyle={styles.buttonText}
                                                                            containerStyle={styles.button}
                                                                            text="View Outfits"
                                                                            onPress={() =>
                                                                                handleViewOutfit(item?.outfits)
                                                                            }
                                                                        />
                                                                    )}
                                                                </View>
                                                            )}
                                                        </View>
                                                    </View>
                                                    <VText
                                                        style={{
                                                            fontSize: fp(10),
                                                            fontWeight: "300",
                                                            color: "#888888",
                                                            marginLeft: spH(40),
                                                        }}
                                                    >
                                                        {new Date(item?.createdDate).toLocaleTimeString("en-US", {
                                                            hour: "2-digit",
                                                            minute: "2-digit",
                                                        }) +
                                                            ", " +
                                                            new Date(item?.createdDate).toLocaleDateString("en-US", {
                                                                day: "2-digit",
                                                                month: "short",
                                                            })}
                                                    </VText>
                                                </View>
                                            );
                                        }
                                }
                            })}
                        {isTyping && (
                            <View style={{ alignItems: "flex-start", width: "100%" }}>
                                <View style={{ flexDirection: "row", alignItems: "center", gap: spH(10) }}>
                                    <View>
                                        <View
                                            style={{
                                                flexDirection: "row",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                height: hp(50),
                                            }}
                                        >
                                            <JumpingDots />
                                        </View>
                                    </View>
                                </View>
                            </View>
                        )}
                    </ScrollView>
                    <View style={{ flexDirection: "row" }}>
                        <View
                            style={{
                                flexDirection: "row",
                                width: wp(280),
                                height: hp(100),
                                marginVertical: spV(20),
                                justifyContent: "center",
                                alignItems: "center",
                                paddingHorizontal: spH(0),
                                borderWidth: 1,
                                borderColor: "#E7E7E7",
                                backgroundColor: promentCount < 3 ? "white" : "#F5F5F5",
                            }}
                        >
                            <View
                                style={{
                                    position: "relative",
                                    left: spH(10),
                                    height: hp(100),
                                    width: wp(30),
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <Image
                                    source={Svg.aiIcon}
                                    accessibilityLabel="AI Icon"
                                    style={{
                                        width: wp(20),
                                        height: hp(20),
                                        tintColor: promentCount >= 3 ? "#888888" : null,
                                        position: "absolute",
                                        top: spH(10),
                                        left: spH(0),
                                    }}
                                />
                            </View>
                            <Input
                                propStyle={{ height: hp(75) }}
                                multiline={true}
                                numberOfLines={4}
                                enableEnter={promentCount < 3}
                                disableFullscreenUI={true}
                                onPressEnter={handleSendMessage}
                                containerStyle={{ flex: 1 }}
                                inputContainerStyle={{
                                    height: hp(75),
                                    color: "black",
                                    fontSize: fp(18),
                                    paddingHorizontal: spH(10),
                                    border: "none",
                                }}
                                placeholderTextColor="#2124274D"
                                placeholder={
                                    promentCount < 3
                                        ? "Send a message "
                                        : "You already asked three prompts on our desktop version."
                                }
                                value={inputValue}
                                editable={promentCount < 3}
                                onChangeText={(text) => {
                                    if (promentCount < 3) {
                                        setInputValue(text);
                                        if (text.length > 0) {
                                        }
                                    }
                                }}
                            />
                            {isTranscript && (
                                <TouchableOpacity
                                    style={{
                                        position: "absolute",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        right: spH(2),
                                        top: spV(5),
                                    }}
                                    onPress={() => {
                                        setIsTranscript(false);
                                        setInputValue("");
                                    }}
                                >
                                    <Image
                                        accessibilityLabel="Close Button"
                                        source={Svg.closeButtonDark}
                                        style={{ width: wp(20), height: hp(20) }}
                                    />
                                </TouchableOpacity>
                            )}
                        </View>
                        <TouchableOpacity
                            disabled={promentCount >= 3}
                            onPress={handleMicPress}
                            style={{ width: wp(30), height: "100%", justifyContent: "center", alignItems: "center" }}
                        >
                            <Image
                                source={Svg.micIcon}
                                accessibilityLabel="Mic Icon"
                                style={{
                                    width: wp(20),
                                    height: hp(20),
                                    tintColor: promentCount >= 3 ? "#888888" : isMicRecording ? "#888888" : null,
                                }}
                            />
                        </TouchableOpacity>
                        {imageUrl && (
                            <View style={{ marginTop: spV(20) }}>
                                <Image
                                    accessibilityLabel="Image"
                                    source={{ uri: imageUrl }}
                                    style={{ width: wp(70), height: hp(100) }}
                                />
                            </View>
                        )}
                        {(imageUrl || inputValue) && (
                            <TouchableOpacity
                                onPress={handleSendMessage}
                                style={{
                                    height: "100%",
                                    marginLeft: spH(10),
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                            >
                                <Image
                                    accessibilityLabel="Send Button"
                                    source={Svg.sendButton}
                                    style={{ width: wp(40), height: hp(40) }}
                                />
                            </TouchableOpacity>
                        )}
                    </View>
                    <View style={{ alignItems: "center", marginBottom: spV(10), marginTop: spV(30) }}>
                        {promentCount < 3 && (
                            <VText style={{ fontSize: fp(12), fontWeight: "300" }}>
                                You can ask three prompts on our desktop version.
                            </VText>
                        )}
                        <VText style={{ fontSize: fp(12), fontWeight: "300" }}>
                            To continue the conversation and unlock more features{" "}
                        </VText>
                        <VText
                            onPress={handleDownloadApp}
                            style={{ textDecorationLine: "underline", fontSize: fp(12), fontWeight: "300" }}
                        >
                            Download the Vêtir app.
                        </VText>
                    </View>
                </View>
            )}
            <DownloadAppModal ref={_downloadAppRef} />
            <OutfitProductsModal ref={_outfitProductsModalRef} productsData={selectedProducts} />
            <GuestDownloadModal ref={_guestDownloadModalRef} />
        </View>
    );
};

const styles = StyleSheet.create({
    closeButton: {
        position: "absolute",
        left: spH(20),
        top: spV(30),
        zIndex: 1000,
    },

    title: {
        alignSelf: "center",
        marginTop: spV(32),
        fontFamily: "LibreBodoni",
        fontSize: fp(28),
        fontWeight: "300",
    },
    description: {
        marginTop: spV(10),
        fontSize: fp(16),
        width: wp(330),
        fontWeight: "300",
        textAlign: "center",
        lineHeight: fp(24),
        marginBottom: spV(50),
    },
    userMessage: {
        fontSize: fp(16),
        fontWeight: "300",
        marginVertical: spV(10),
        alignItems: "right",
        backgroundColor: "#21242799",
        padding: spH(10),
        color: "white",
        borderRadius: fp(20),
    },
    AIMessage: {
        marginVertical: spV(10),
        borderWidth: 1,
        borderColor: "#E7E7E7",
        borderRadius: fp(20),
        padding: spH(20),
        width: wp(430),
        overflow: "hidden",
        // backgroundColor: "red"
    },
    carouselContainer: {
        marginVertical: spV(10),
        borderWidth: 1,
        borderColor: "#E7E7E7",
        borderRadius: fp(16),
        paddingVertical: spV(10),
        paddingHorizontal: spH(2),
        width: wp(430),
        overflow: "hidden",
        // backgroundColor: "red"
    },
    button: {
        width: wp(280),
        height: hp(36),
        borderRadius: fp(1),
        backgroundColor: "#D8D8D8",
    },
    buttonText: {
        color: "black",
        fontSize: fp(16),
        fontWeight: "350",
    },
});

export default PdpStylistView;
